import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { seoHead } from '@/lib/seoHead';
import { BrandDealsPage, dealsQuery } from '@/components/deals/DealsPages';
import { ComparisonError } from '@/components/comparison/ComparisonError';

const schema = z.object({
  q: z.string().max(80).optional(), category: z.string().max(80).optional(),
  color: z.string().max(20).optional(), promo: z.coerce.number().int().min(0).max(1).optional(), audience: z.string().max(20).optional(),
  sort: z.enum(['discount', 'price', 'recent']).optional(), page: z.coerce.number().int().min(0).max(100).optional(),
  min: z.coerce.number().min(0).optional(), max: z.coerce.number().min(0).optional(),
});

export const Route = createFileRoute('/promocoes/$slug')({
  validateSearch: schema,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps, params }) => context.queryClient.ensureQueryData(dealsQuery({ ...deps, brand: params.slug })),
  head: ({ loaderData, params }) => {
    const b = loaderData?.brand;
    if (!b) return seoHead({ title: 'Loja indisponível | Shopping do Bem', description: 'Esta loja não está disponível no momento. Veja outras ofertas das lojas parceiras.', noindex: true });
    const month = new Intl.DateTimeFormat('pt-BR', { month: 'long', year: 'numeric', timeZone: 'America/Sao_Paulo' }).format(new Date());
    return seoHead({
      title: `Promoções ${b.name} ${month} | Shopping do Bem`.slice(0, 70),
      description: `Produtos em promoção na ${b.name} com desconto real${b.donation_percentage ? ` e ${Number(b.donation_percentage).toLocaleString('pt-BR')}% de doação` : ''} para causas sociais, sem custo extra.`,
      path: `/promocoes/${b.slug || params.slug}`,
      noindex: !loaderData.items.length,
      ogImage: b.logo_url ?? null,
    });
  },
  component: function PromocoesMarca() {
    const { slug } = Route.useParams();
    return <BrandDealsPage slug={slug} search={Route.useSearch()} />;
  },
  errorComponent: ({ reset }) => <ComparisonError reset={reset} />,
});
